"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitLogin = void 0;
const axios_1 = __importDefault(require("axios"));
const urls_1 = require("./urls");
const AxiosErrorParse_utils_1 = require("../utils/AxiosErrorParse.utils");
/**
 * Function to submit username and password for login
 */
function submitLogin(v) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield axios_1.default.post(urls_1.fullURLS.AUTH, v);
            return { success: res.status === 200, data: res.data };
        }
        catch (err) {
            if (err.response.data.error) {
                return err.response.data;
            }
            return AxiosErrorParse_utils_1.AxiosErrorParse(err);
        }
    });
}
exports.submitLogin = submitLogin;
//# sourceMappingURL=auth.js.map